import styled from 'styled-components';
import { getFont } from '@finect/tabular-utils/getFont';
export var RadioBlock = styled.div.withConfig({
  displayName: "RadioBlock",
  componentId: "sc-1tbwagi-0"
})(["input{display:none;}label{display:inline-block;position:relative;width:100%;padding-left:30px;cursor:pointer;", ";&:before{position:absolute;top:2px;left:0;width:21px;height:21px;border-radius:50%;content:'';}&:before{border:1px solid ", ";background-color:#fff;}svg{position:absolute;z-index:1;top:5px;left:3px;opacity:0;color:#fff;}}input:checked + label{&:after,svg{opacity:1;}}"], getFont(0), function (_ref) {
  var theme = _ref.theme,
    $isChecked = _ref.$isChecked;
  return $isChecked ? theme.checkboxActiveColor || theme.mainColor : theme.checkboxColor || theme.checkboxActiveColor || theme.mainColor;
});